import { lazy, useMemo } from 'react';
import { ComponentType } from '@mews-commander/ui';
import { ReactQueryDevtools as MewsReactQueryDevtools } from '@mews/framework';
import FontProvider from '@optimus-web/fonts';
import getGlobalStyles from './getGlobalStyles';
import { getMountElement, renderReactNodeWithContext } from './render';
import { TanStackAppProps } from './tanStackRouter';

const TanStackApp = lazy(async () =>
    import(/* webpackChunkName: "tanStackRouter" */ './tanStackRouter').then((module) => ({
        default: module.TanStackApp,
    }))
);

export const renderApp = (elementId: string) => async (routerProps: TanStackAppProps) => {
    const rootElement = getMountElement(elementId, ComponentType.App);

    return renderReactNodeWithContext(<AppComponent {...routerProps} />, rootElement);
};

const AppComponent = (routerProps: TanStackAppProps) => {
    const GlobalStyles = useMemo(getGlobalStyles, []);

    return (
        <>
            <GlobalStyles />
            <FontProvider />
            <TanStackApp {...routerProps} />
            <MewsReactQueryDevtools initialVisibility={false} />
        </>
    );
};
